import React from 'react';

import {withRouter, WithRouterProps} from 'react-router';

import {
  applyFilter,
  DashboardFilterbar,
} from 'app/general/dashboards/DashboardFilterbar';
import {DashboardFilterbarContentType} from 'app/general/dashboards/DashboardFilterbarContentType';
import {DashboardFilterbarSort} from 'app/general/dashboards/DashboardFilterbarSort';
import {SearchInputField} from 'app/general/widgets/SearchInputField';
import {RECYCLEABLE_CONTENT_TYPES, SORT_BY_TYPES} from 'app/utils/constants';

import type {RecycleBinLocationParamsType} from 'app/recycle-bin/types';

const sortOptions = [
  SORT_BY_TYPES.DELETION_DATE,
  SORT_BY_TYPES.ALPHABETICALLY_CURRENT_NAME,
];

const recycleableContentTypeOptions = Object.values(RECYCLEABLE_CONTENT_TYPES);

interface Props extends WithRouterProps<RecycleBinLocationParamsType> {
  viewingAll: boolean;
  resetFilters: () => void;
}

export const RecycleBinFilterbar = withRouter(function ({
  resetFilters,
  viewingAll,
  router,
  location,
}: Props) {
  const {query} = location;

  const getSortOptions = () => {
    return location.query.search == null
      ? sortOptions.filter((i) => i !== SORT_BY_TYPES.RANK)
      : sortOptions;
  };

  const changeFilter = (
    filters: Record<string, number | string | null | void>
  ) => {
    return applyFilter(router, location, filters);
  };

  const onSearch = (search) => {
    changeFilter({
      search,
    });
  };

  const onContentTypeChange = (content_type: string) => {
    changeFilter({
      content_type,
    });
  };

  const onSort = (ordering: string) => {
    changeFilter({
      ordering,
    });
  };

  return (
    <DashboardFilterbar resetFilters={resetFilters} viewingAll={viewingAll}>
      <div className="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0 pr-sm-2">
        <SearchInputField
          value={query.search != null ? query.search : ''}
          onChange={onSearch}
        />
      </div>
      <div className="col-12 col-sm-6 col-lg mb-2 mb-lg-0 pr-lg-2">
        <DashboardFilterbarSort
          value={query.ordering}
          onChange={onSort}
          options={getSortOptions()}
          backendDefaultSort={SORT_BY_TYPES.DELETION_DATE}
        />
      </div>
      <div className="col-12 col-sm-6 col-lg-4 col-xl pr-md-0 pr-lg-2 mb-xl-0">
        <DashboardFilterbarContentType
          value={query.content_type}
          onChange={onContentTypeChange}
          options={recycleableContentTypeOptions}
        />
      </div>
    </DashboardFilterbar>
  );
});
